import React from 'react';
import { SvgIcon } from '@mui/material';
import { DocumentsIconProps } from './DocumentsIcon.props';

const FONT_SIZE_MAP = {
  inherit: 'inherit',
  small: 24,
  medium: 40,
  large: 56,
};

export const DocumentsIcon: React.FC<DocumentsIconProps> = ({
  fontSize = 'medium',
  sx,
  ...props
}) => {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 56 56"
      sx={{
        fontSize: FONT_SIZE_MAP[fontSize],
        width: FONT_SIZE_MAP[fontSize],
        height: FONT_SIZE_MAP[fontSize],
        ...sx,
      }}
    >
      <rect width="56" height="56" rx="12" fill="#CBD5E1" fillOpacity="0.5" />
      <path
        d="M21 26L24 29"
        stroke="#A1B0C3"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M28 21L28 28"
        stroke="#A1B0C3"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M35 26L32 29"
        stroke="#A1B0C3"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M46.4883 10L51.5342 15.0459V27.2881C51.5341 27.6695 51.383 28.036 51.1133 28.3057C50.8436 28.5753 50.4771 28.7265 50.0957 28.7266H39.4385C39.0571 28.7265 38.6906 28.5754 38.4209 28.3057C38.1512 28.0359 38 27.6695 38 27.2881V11.4385C38 11.057 38.1512 10.6906 38.4209 10.4209C38.6906 10.1512 39.057 10 39.4385 10H46.4883Z"
        fill="#BCC6D2"
      />
      <rect
        x="39.6309"
        y="17.4609"
        width="9.24014"
        height="1.63061"
        rx="0.815306"
        fill="white"
      />
      <rect
        x="39.6309"
        y="21.2656"
        width="6.52245"
        height="1.63061"
        rx="0.815306"
        fill="white"
      />
      <path
        d="M51.534 15.0456L46.4883 10V13.6074C46.4883 13.9888 46.6399 14.3546 46.9096 14.6243C47.1793 14.894 47.5451 15.0455 47.9265 15.0456H51.534Z"
        fill="#A1B0C3"
      />
      <path
        d="M13.4883 10L18.5342 15.0459V27.2881C18.5341 27.6695 18.383 28.036 18.1133 28.3057C17.8436 28.5753 17.4771 28.7265 17.0957 28.7266H6.43848C6.05706 28.7265 5.6906 28.5754 5.4209 28.3057C5.15119 28.0359 5 27.6695 5 27.2881V11.4385C5 11.057 5.15118 10.6906 5.4209 10.4209C5.69061 10.1512 6.05704 10 6.43848 10H13.4883Z"
        fill="#BCC6D2"
      />
      <rect
        x="6.63086"
        y="17.4609"
        width="9.24014"
        height="1.63061"
        rx="0.815306"
        fill="white"
      />
      <rect
        x="6.63086"
        y="21.2656"
        width="6.52245"
        height="1.63061"
        rx="0.815306"
        fill="white"
      />
      <path
        d="M18.534 15.0456L13.4883 10V13.6074C13.4883 13.9888 13.6399 14.3546 13.9096 14.6243C14.1793 14.894 14.5451 15.0455 14.9265 15.0456H18.534Z"
        fill="#A1B0C3"
      />
      <path
        d="M38.7647 38.0588V34.9216C38.7647 34.0553 38.0926 33.3529 37.2637 33.3529H27.309C26.7405 33.3529 26.2207 33.0173 25.9663 32.4859L25.6702 31.8671C25.4158 31.3357 24.8961 31 24.3276 31H18.501C17.6721 31 17 31.7024 17 32.5686V40.4118H38.3895L38.7647 38.0588Z"
        fill="#A1B0C3"
      />
      <path
        d="M37.0009 39.8236V35.8417C37.0009 35.4417 36.6609 35.1177 36.2411 35.1177H19.5254C19.1056 35.1177 18.7656 35.4417 18.7656 35.8417V39.8236H37.0009Z"
        fill="white"
      />
      <path
        d="M38.7643 37.8421V49.452C38.7643 50.3069 38.0923 51 37.2633 51H18.501C17.6721 51 17 50.3069 17 49.452V40.1641C17 39.3092 17.6721 38.6161 18.501 38.6161H28.4555C29.024 38.6161 29.5438 38.2848 29.7982 37.7605L30.0942 37.1498C30.3487 36.6254 30.8684 36.2941 31.4369 36.2941H37.2637C38.0926 36.2941 38.7643 36.9872 38.7643 37.8421Z"
        fill="#BCC6D2"
      />
      <path
        d="M29.5264 5L34 8.96777V18.5957C33.9999 18.8956 33.8651 19.1834 33.626 19.3955C33.3869 19.6074 33.0626 19.7265 32.7246 19.7266H23.2754C22.9372 19.7265 22.6122 19.6076 22.373 19.3955C22.134 19.1835 22.0001 18.8955 22 18.5957V6.13086C22 5.83101 22.134 5.54311 22.373 5.33105C22.6122 5.11895 22.9372 5 23.2754 5H29.5264Z"
        fill="#BCC6D2"
      />
      <rect
        x="23.4434"
        y="10.8672"
        width="8.19264"
        height="1.28231"
        rx="0.641156"
        fill="white"
      />
      <rect
        x="23.4434"
        y="13.8593"
        width="5.78304"
        height="1.28231"
        rx="0.641156"
        fill="white"
      />
      <path
        d="M33.9972 8.96783L29.5234 5V7.83683C29.5235 8.13677 29.6578 8.42442 29.897 8.63652C30.1361 8.84861 30.4604 8.96778 30.7986 8.96783H33.9972Z"
        fill="#A1B0C3"
      />
    </SvgIcon>
  );
};

export default DocumentsIcon;
